var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOatColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 5,
    fill: "#F3F3F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95561 14.422C9.63337 13.9988 9.41499 13.4922 9.33846 12.9403H5C5.10072 14.6835 5.79577 16.2673 6.88558 17.4921L9.95561 14.422Z",
    fill: "#FF028B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33846 12.0599C9.41499 11.508 9.63337 11.0014 9.95561 10.5782L6.88558 7.50812C5.79577 8.73292 5.10072 10.3167 5 12.0599H9.33846Z",
    fill: "#AC01FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9404 5V9.35701C13.4861 9.43555 13.9868 9.65279 14.4059 9.97187L17.4922 6.88558C16.2674 5.79577 14.6836 5.10072 12.9404 5V5Z",
    fill: "#00FFD1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5801 9.9579C11.0038 9.6402 11.5094 9.42592 12.0596 9.3525V5C10.3164 5.10072 8.73262 5.79577 7.50781 6.88557L10.5801 9.9579Z",
    fill: "#0094FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6295 12.9403C15.5541 13.4842 15.3409 13.9841 15.0264 14.4036L18.1149 17.4921C19.2047 16.2673 19.8998 14.6835 20.0005 12.9403H15.6295Z",
    fill: "#FFE600"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0264 10.5967C15.3409 11.0161 15.5541 11.516 15.6295 12.0599H20.0005C19.8998 10.3167 19.2047 8.73292 18.1149 7.50812L15.0264 10.5967Z",
    fill: "#05FF00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0596 15.6477C11.5094 15.5743 11.0038 15.36 10.5801 15.0423L7.50781 18.1146C8.73265 19.2044 10.3164 19.8995 12.0596 20.0002V15.6477Z",
    fill: "#F31558"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4059 15.0283C13.9869 15.3474 13.4861 15.5646 12.9404 15.6432V20.0002C14.6836 19.8995 16.2674 19.2044 17.4922 18.1146L14.4059 15.0283Z",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOatColor);
export default __webpack_public_path__ + "static/media/oat-color.9cc8de8e.svg";
export { ForwardRef as ReactComponent };